import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PdfPreviewStore {
  isOpen: boolean;
  toggle: () => void;
  open: () => void;
  close: () => void;
}

export const usePdfPreviewStore = create<PdfPreviewStore>()(
  persist(
    (set) => ({
      isOpen: false,
      toggle: () => set((s) => ({ isOpen: !s.isOpen })),
      open: () => set({ isOpen: true }),
      close: () => set({ isOpen: false }),
    }),
    { name: 'pdf-preview-panel', version: 1 },
  ),
);
